import { render } from "./platform-landing.vue?vue&type=template&id=5fdc5d4d&scoped=true"
import script from "./platform-landing.vue?vue&type=script&lang=js"
export * from "./platform-landing.vue?vue&type=script&lang=js"

import "./platform-landing.vue?vue&type=style&index=0&id=5fdc5d4d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fdc5d4d"]])

export default __exports__